import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'delta', 'IconDelta', [["path",{"d":"M4 20h16l-8 -16z","key":"svg-0"}]]);